import styled from '@emotion/styled'

export const Box = styled('div')``

export const Title = styled('div')`
  font-weight: 400;
  font-size: 24px;
  padding-bottom: 8px;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
`

export const Subtitle = styled('div')`
  color: #666666;
  font-weight: 400;
  font-size: 14px;
`

export const SubtitleTextBold = styled('span')`
  color: #000000;
`
